import { Store } from 'game/store/gameStore';
import { HintButton } from './HintButton';
import { MagicWandButton } from './MagicWandButton';
import { UndoButton } from './UndoButton';

export function createGameButtons() {
    new UndoButton(0); //count from right to left
    new HintButton(1);
    
    if (!Store.isPyramid) {
        new MagicWandButton(2);
    }
}
